/** Public marketing page. */
export const LANDING_PATH = "/";

/** Match list after opening the app. */
export const APP_HOME_PATH = "/app";

/** True when the site is running as an installed PWA. */
export const isStandaloneDisplay = () => {
  if (
    typeof window === "undefined" ||
    typeof window.matchMedia !== "function"
  ) {
    return false;
  }

  const media = window.matchMedia("(display-mode: standalone)").matches;
  const iosStandalone =
    "standalone" in navigator &&
    (navigator as Navigator & { standalone?: boolean }).standalone === true;

  return media || iosStandalone;
};
